<footer ng-controller="FooterCtrl" class="main-footer" ng-class="{'footer-default': typeof (appClient === undefined),'footer-client': appClient === 'client','footer-technician': appClient === 'technician'}">
  <div class=" pull-left hidden-xs version-footer">
    <!--<b>Version</b> 0.0.0.1-->
  </div>
  <span class="text-footer">
    <a href="http://xpectra.com" target="_blank">XPECTRA </a>- Copyright@2016
  </span>
</footer>
